import { StoryblokTextCol } from './StoryblokTextCol'

import { createTextCol } from './__mocks__/textCol'

export { createTextCol }

// Re-export for backward compatibility
export const dummyBlokTextColStoryblok = createTextCol()

export default StoryblokTextCol
